var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 49,
    height: 37,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13116_36147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0684 35.6771C19.7525 35.3612 19.5949 34.9896 19.5956 34.5622C19.5964 34.1348 19.754 33.7632 20.0684 33.4473L28.9876 24.528L20.0684 15.6087C19.7525 15.2928 19.5949 14.9212 19.5956 14.4938C19.5964 14.0664 19.754 13.6948 20.0684 13.3789C20.3828 13.063 20.7544 12.9054 21.1833 12.9062C21.6121 12.9069 21.9838 13.0645 22.2982 13.3789L32.3324 23.4131C32.6483 23.729 32.8062 24.101 32.8062 24.5291C32.8062 24.9572 32.6483 25.3285 32.3324 25.6429L22.2982 35.6771C21.9823 35.993 21.6103 36.1509 21.1822 36.1509C20.754 36.1509 20.3828 35.993 20.0684 35.6771ZM31.2175 35.6771C30.9016 35.3612 30.744 34.9896 30.7447 34.5622C30.7455 34.1348 30.903 33.7632 31.2175 33.4473L40.1367 24.528L31.2175 15.6087C30.9016 15.2928 30.744 14.9212 30.7447 14.4938C30.7455 14.0664 30.903 13.6948 31.2175 13.3789C31.5319 13.063 31.9035 12.9054 32.3324 12.9062C32.7612 12.9069 33.1329 13.0645 33.4473 13.3789L43.4814 23.4131C43.7973 23.729 43.9553 24.101 43.9553 24.5291C43.9553 24.9572 43.7973 25.3285 43.4814 25.6429L33.4473 35.6771C33.1314 35.993 32.7594 36.1509 32.3312 36.1509C31.9031 36.1509 31.5319 35.993 31.2175 35.6771Z",
    fill: "#07523E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13116_36147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.8413,
    height: 37.8413,
    fill: "white",
    transform: "translate(26.7578) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootericon);
export default __webpack_public_path__ + "static/media/footericon.0898427bf7694bc237716ceb5a07d2e7.svg";
export { ForwardRef as ReactComponent };